module.exports = __webpack_public_path__ + "img/intelligence.a236580e.svg";